var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useUserContext } from '@web/contexts/User';
import { trpc } from '@web/lib/trpc';
import React from 'react';
export var WorkspaceContext = React.createContext({
    users: [],
    orgUnits: [],
    labels: [],
    isLoading: true,
    userCtxRefetch: function () { }
});
export var useWorkspaceCtx = function () { return React.useContext(WorkspaceContext); };
export function WorkspaceContextProvider(_a) {
    var children = _a.children;
    var currentUser = useUserContext().currentUser;
    if (!currentUser || !currentUser.workspaceId)
        return _jsx(_Fragment, { children: children });
    var usersQuery = trpc.users.useQuery();
    var orgUnitsQuery = trpc.orgUnits.useQuery();
    var labelsQuery = trpc.getAllLabels.useQuery();
    var users = usersQuery.data || [];
    var orgUnits = orgUnitsQuery.data || [];
    var labels = labelsQuery.data || [];
    var isLoading = usersQuery.isLoading || orgUnitsQuery.isLoading || labelsQuery.isLoading;
    return (_jsx(WorkspaceContext.Provider, __assign({ value: {
            users: users,
            orgUnits: orgUnits,
            labels: labels,
            isLoading: isLoading,
            userCtxRefetch: usersQuery.refetch
        } }, { children: children })));
}
